module.exports = require("./fr-MU");